<template>
  <el-table-column
    prop="status"
    sortable="custom"
    label="Státusz"
    show-overflow-tooltip
    min-width="130"
  >
    <template slot-scope="scope">
      <el-tag v-if="scope.row.status === 'recorded'" size="small" type="info">Rögzítve</el-tag>
      <el-tag v-if="scope.row.status === 'done'" size="small" type="success"><i class="el-icon-success"></i> Lezárva</el-tag>
      <el-tooltip
        v-if="scope.row.status === 'modified'"
        effect="dark"
        :content="`Módosítja a következő: ${scope.row.modify_invoice_number}`"
        placement="right"
      >
        <el-tag v-if="scope.row.status === 'modified'" size="small" type="warning"><i class="el-icon-warning"></i> Módosítva</el-tag>
      </el-tooltip>
      <el-tooltip
        v-if="scope.row.status === 'cancelled'"
        effect="dark"
        :content="`Sztornózza a következő: ${scope.row.cancel_invoice_number}`"
        placement="right"
      >
        <el-tag v-if="scope.row.status === 'cancelled'" size="small" type="danger"><i class="el-icon-error"></i> Sztornózva</el-tag>
      </el-tooltip>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'status',
};
</script>
